<div class="login-form">
  <div class="flex-column">
    <p class="h1 uppercase text-center">
      По техническим причинам<br />
      сервис недоступен
    </p>
    <span class="text-3 text-center">
      Спешно чиним, примите извинения за неудобства.<br /> Мы ценим Вас за выбор
      данного сервиса.
    </span>
    <app-button (click)="handleNavigate()" [title]="'вернуться назад'" class="uppercase">вернуться назад</app-button>
  </div>
</div>
